export const LOADING_COURSEFUNCION = "LOADING_COURSEFUNCION";
export const SAVE_LOADING_COURSEFUNCION = "SAVE_LOADING_COURSEFUNCION";
export const GET_COURSEFUNCION = "GET_COURSEFUNCION";
export const FORM_FAIL = "FORM_FAIL";
export const COURSEFUNCION_FAIL = "COURSEFUNCION_FAIL";
export const GET_COURSEFUNCION_BY_ID = "GET_COURSEFUNCION_BY_ID";

//cursos
export const LOADING_COURSE = "LOADING_COURSE";
export const SAVE_LOADING_COURSE = "SAVE_LOADING_COURSE";
export const GET_COURSE = "GET_COURSE";
export const COURSE_FAIL = "COURSE_FAIL";
export const LOADING_COURSE_BY_ID = "LOADING_COURSE_BY_ID";
export const GET_COURSE_BY_ID = "GET_COURSE_BY_ID";
//
export const LOADING_TASK = "LOADING_TASK";
export const SAVE_LOADING_TASK = "SAVE_LOADING_TASK";
export const GET_TASKS = "GET_TASKS";
export const TASK_FAIL = "TASK_FAIL";
export const LOADING_TASK_BY_ID = "LOADING_TASK_BY_ID";
export const GET_TASK_BY_ID = "GET_TASK_BY_ID";

